module.exports = __webpack_public_path__ + "img/Telegram_color.8332763.svg";